export default {
      id: "video-request_done-usage",
      viewBox: "0 0 22 19",
      url: __webpack_public_path__ + "img/icons.svg#video-request_done",
      toString: function () {
        return this.url;
      }
    }